import api from '@/api/'

export const strategyCommand = {
  edit(data) {
    this.isEdit = true
    this.visible = true
    this.$nextTick(() => {
      this.waitItem = { ...data }
    })
  },
  delete(data) {
    const _this = this
    this.$confirm({
      content: '删除后不可恢复，确定要删除吗？',
      okText: "确定",
      cancelText: "取消",
      async onOk() {
        const res = await api.companyAddressDel({ id: data.id })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功！')
          _this.getList()
        }
      }
    })
  }
}
